import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  MenuItem,
  Select,
  FormControlLabel,
  FormControl,
  Autocomplete,
  Button,
} from "@material-ui/core";
import Tooltip from "@mui/material/Tooltip";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { makeStyles } from "@material-ui/styles";
import { Checkbox } from "@material-ui/core";
import { BackupTable, Delete } from "@material-ui/icons";
import moment from "moment";
import VendorCode from "../../NewInvoice/Dropdowns/VenderCode";
import UsersByRole from "../../NewInvoice/Dropdowns/UsersByRole";
// import GL_Table from "../../NewInvoice/Tables/GL_Table";
// import Vendor_Table from "../../NewInvoice/Tables/Vendor_Table";
// import CommentHistory from "../../NewInvoice/Tables/CommentHistory";
import PODetail from "../../NewInvoice/Tables/PoDetail_Table";
import {
  deleteAttachment,
  // getRefrenceDataList,
  uploadAdditioalDocumentFile,
  // uploadFile,
  uploadFile_v1,
} from "../../actions";
import { demandType, category } from "../../../Home/constant";
import { dashboardStyle } from "./style.js";
import { Download } from "@material-ui/icons";
import downloadAttachments from "../../../../Functions/downloadAttachments";
import { formatDateTimeForBackend } from "../../../../Functions";
// import isAboveToday from "../../../../Functions/isAboveToday";
import isOldDateValidate from "../../../../Functions/isOldDateValidate.js";
import WarningBox from "../WarningBox";
import isFutureDate from "../../../../Functions/isFutureDate";
import POAlertDialog from "../../NewInvoice/Tables/PoTableAlert";
import getParameterByName from "../../../../Functions/functions";
import jwt from "jsonwebtoken";
const useStyles = makeStyles(dashboardStyle);
const token = localStorage.getItem("user_token");
const user = jwt.decode(token);
const InvoiceTextField = ({
  formState,
  newFormState,
  setNewFormState,
  selectedRole,
  disabled,
  poBasedState,
  showVendorAndPO_NumberForImport,
  showVendorCodeForImport,
  invoice_attachmentRef,
  additionalAttachmentRef,
  setAttachInvoiceLoading,
  // setAttchmentFile_UI,
  // attachmentFile_UI,
  physicalOrEInvoice,
  changeHandler,
  alignForAttachment,
  showAttachmentsHandler,
  attachmentURLList,
  setAttachmentURL,
  setAttachmentURLList,
  // dNInvoicesorITNInvoices,
  edit,
  fields,
  setOpenInvalidWarningDate,
  setInvalidWarningDateState,
  multipleData,
  invoicePayload,
  hide,
  setSuccessMessage,
}) => {
  const classes = useStyles();
  const roleName = getParameterByName("roleName"); // get role name for show attachment
  const invoiceEdit = getParameterByName("edit"); // get form url
  const status = getParameterByName("status");

  const [openWarningBox, setOpenWarningBox] = useState(false);
  const [currentStateForDeleteion, setCurrentStateForDeleteion] = useState("");
  const [alertMessage, setAlertMessage] = useState(false);
  const [attachError, setAttachError] = useState("");
  const [docError, setDocError] = useState("");
  const [deleteLoader, setdeleteLoader] = useState(false);
  const [attachmentFile_UI, setAttchmentFile_UI] = useState([]);

  const dateStyle = {
    color: disabled ? "#B4B4B4" : null,
    backgroundColor: disabled ? "white" : null,
    borderColor: disabled ? "#B4B4B4" : null,
    cursor: disabled ? "default" : null,
    height: 13,
  };

  const deleteAttachmentFunc = () => {
    deleteAttachment(
      setNewFormState,
      setAttachmentURLList,
      setOpenWarningBox,
      newFormState,
      attachmentURLList,
      currentStateForDeleteion,
      setdeleteLoader
    );
    // let ss = currentStateForDeleteion?.ss;
    // let f = currentStateForDeleteion?.f;
    // const files = newFormState?.additionalDocIds.filter((x, i) => {
    //   const n = x?.path.split("\\");
    //   const nn = n[n.length - 1];
    //   return nn !== ss;
    // });
    // setNewFormState((newFormState) => ({
    //   ...newFormState,
    //   additionalDocIds: files,
    // }));

    //
    // //removing data from attachemt list for preview
    // let filtered_attachs = attachmentURLList?.filter((x) => x !== f);
    // setAttachmentURLList(filtered_attachs);
    // setAttachmentURL(filtered_attachs[filtered_attachs.length - 1]);
    // setOpenWarningBox(false);
  };
  const [warningFlag, setWarningFlag] = useState(false);

  const deleteInvoice = () => {
    const data = {
      Id: newFormState?.invoice_attachment?.id,
    };
    setdeleteLoader(true);
    var axios = require("axios");
    var config = {
      method: "delete",
      url: `${process.env.REACT_APP_API_URL}/api/UploadFile/DeleteAttachment`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("user_token")}`,
      },
      params: data,
    };

    axios(config)
      .then(function (response) {
        const final = attachmentURLList?.filter(function (item) {
          return ![newFormState?.invoice_attachment?.path].includes(item);
        });

        const filteredAttachmentsSR = newFormState?.attachment_Sr.filter(
          (x) => x !== newFormState?.invoice_attachment?.id
        );
        setAttachmentURLList(final);
        setNewFormState((formState) => ({
          ...formState,
          invoice_attachment: "",
          attachment_Sr: filteredAttachmentsSR,
        }));
        invoice_attachmentRef.current.value = null;
        setOpenWarningBox(false);
        setdeleteLoader(false);
        setSuccessMessage(response.data);
      })
      .catch(function (error) {
        // setErrorMessage(error.response.data);
      });
  };

  const formatDate = () => {
    
    if(formState?.po_Date !== "" || formState?.po_Date !== null ){
      return formState?.po_Date?.split("-")?.reverse()?.join("/") || ""
    }
  };
  const PODate = formatDate();

  useEffect(() => {
    if (selectedRole === "IP") {
      if (newFormState.pO_Based) {
        setNewFormState(() => ({
          ...newFormState,
          po_Date: PODate,
        }));
      } else {
        setNewFormState(() => ({
          ...newFormState,
          po_Date: new Date().toString(),
        }));
      }
    }
  }, [PODate]);

  const getVendorDisplayName = (vendorName) => {
    const parts = newFormState?.vendor_Name?.split("-");
    if (parts?.length > 1) {
      // return parts[1]?.trim();
      // If there is a dash, take the part after the first dash and trim any extra spaces
      return parts.slice(1).join("-").trim();
    } else {
      // If there is no dash, return the original name
      return newFormState?.vendor_Name?.trim();
    }
  };

  // Inside your component...

  const VendorName = getVendorDisplayName();
  return (
    <Grid container spacing={1} style={{ marginTop: "2px" }}>
      {(selectedRole === "Import" ||
        (selectedRole === "Loam Approver" && newFormState?.isImport) ||
        (selectedRole === "Department Coordinator" && newFormState?.isImport) ||
        (selectedRole === "IP" &&
          newFormState?.isImport &&
          disabled &&
          !edit)) && (
        <>
          {/* isPSID */}
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <FormControlLabel
              style={{ marginLeft: "3px", color: "black" }}
              label="PSID"
              color="secondary"
              control={
                <Checkbox
                  color="secondary"
                  fontSize="small"
                  checked={newFormState?.isPSID}
                  name="isPSID"
                  disabled={true}
                  onChange={(event) => {
                    setNewFormState((newFormState) => ({
                      ...newFormState,
                      isPSID: event.target.checked,
                    }));
                  }}

                  // disabled={selectedRole === "Logistic"}
                />
              }
            />
          </Grid>
          {/* PSID */}

          {newFormState?.isPSID && (
            <Grid
              item
              xs={12}
              sm={12}
              md={alignForAttachment ? 6 : 3}
              lg={alignForAttachment ? 6 : 3}
            >
              <Typography style={{ color: "black" }}>
                <span className={classes.asterisk}>*</span>PSID:
              </Typography>
              <TextField
                fullWidth
                name="psid"
                type="text"
                value={newFormState?.psid}
                onChange={changeHandler}
                disabled={disabled}
                size="small"
                sx={{
                  "& .MuiInputBase-root": {
                    height: 30,
                  },
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                id="outlined-basic"
                variant="outlined"
              />
            </Grid>
          )}

          {/* Demand type */}
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <FormControl fullWidth size="small">
              <Typography style={{ color: "black" }}>
                <span className={classes.asterisk}>*</span>Demand type:
              </Typography>
              <Select
                size="small"
                // labelId="demo-simple-select-label"
                value={newFormState?.demandType || ""}
                id="demo-simple-select"
                name="demandType"
                onChange={changeHandler}
                displayEmpty
                className={classes.selectEmpty}
                disabled={disabled}
                inputProps={{ "aria-label": "Without label" }}
              >
                <MenuItem value="" disabled>
                  Select a Value
                </MenuItem>
                {demandType.map((item) => {
                  return <MenuItem value={item.role}>{item.role}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Grid>
        </>
      )}

      {/*Efdv invoice below 2 field for reviewer isPCDV  */}
      {newFormState?.isPCDV && !edit && disabled && (
        <>
          {/* PCDV Segment */}

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Typography style={{ color: "black" }}>PCDV Segment:</Typography>
            <TextField
              fullWidth
              name="psid"
              type="text"
              value={newFormState?.pcdvSegment || ""}
              // onChange={changeHandler}
              disabled={true}
              size="small"
              sx={{
                "& .MuiInputBase-root": {
                  height: 30,
                },
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-basic"
              variant="outlined"
            />
          </Grid>

          {/* PCDV Loacation */}
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Typography style={{ color: "black" }}>PCDV Loacation:</Typography>
            <TextField
              fullWidth
              name="psid"
              type="text"
              value={newFormState?.pcdvLocation || ""}
              // onChange={changeHandler}
              disabled={true}
              size="small"
              sx={{
                "& .MuiInputBase-root": {
                  height: 30,
                },
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-basic"
              variant="outlined"
            />
          </Grid>
        </>
      )}
      {newFormState?.isHR && selectedRole === "IP" && disabled ? (
        <Grid
          item
          xs={12}
          sm={12}
          md={alignForAttachment ? 6 : 3}
          lg={alignForAttachment ? 6 : 3}
        >
          <FormControl fullWidth size="small">
            <Typography style={{ color: "black" }}>
              <span className={classes.asterisk}>*</span>Category:
            </Typography>

            <Select
              size="small"
              // labelId="demo-simple-select-label"
              value={newFormState?.invoiceCategory}
              id="demo-simple-select"
              name="invoiceCategory"
              onChange={changeHandler}
              style={{ height: 30 }}
              inputProps={{ "aria-label": "Without label" }}
              displayEmpty
              className={classes.selectEmpty}
              disabled={disabled}
            >
              <MenuItem value="" disabled>
                Select a Value
              </MenuItem>
              {category.map((item) => {
                return <MenuItem value={item.role}>{item.role}</MenuItem>;
              })}
            </Select>
          </FormControl>
        </Grid>
      ) : null}

      {/* ---------------- */}
      {/*vendoe code  */}
      {(showVendorCodeForImport() ||
        // (selectedRole !== "Logistic" && poBasedState == "Non-PO") ||\
        (selectedRole === "Department Coordinator" &&
          poBasedState === "Non-PO" &&
          !newFormState?.isPCDV) ||
        (selectedRole === "TaxTeam" && poBasedState === "Non-PO") ||
        (selectedRole === "Loam Approver" && poBasedState == "Non-PO") ||
        (newFormState?.isImport && poBasedState == "Non-PO") ||
        (selectedRole === "IP" &&
          poBasedState == "Non-PO" &&
          disabled &&
          !newFormState?.isHR)) && (
        <>
          {/* vendor code */}
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <FormControl fullWidth size="small">
              <Typography style={{ color: "black" }}>Vendor Code: </Typography>
              {disabled || selectedRole === "IP" ? (
                <TextField
                  fullWidth
                  size="small"
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 30,
                    },
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  id="outlined-basic"
                  name=""
                  value={newFormState?.vendor_Code?.Vendor_Code}
                  variant="outlined"
                  disabled={disabled || selectedRole === "IP"}
                />
              ) : (
                <VendorCode
                  disabled={disabled}
                  formState={newFormState}
                  changeHandler={changeHandler}
                  bordered={true}
                  user={newFormState?.vendor_Code?.Vendor_Code || ""}
                />
              )}
            </FormControl>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <FormControl fullWidth size="small">
              <Typography style={{ color: "black" }}>Vendor Name: </Typography>
              {disabled || selectedRole === "IP" ? (
                <TextField
                  fullWidth
                  size="small"
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 30,
                    },
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  id="outlined-basic"
                  name=""
                  value={newFormState?.vendor_Code?.Vendor_Name}
                  variant="outlined"
                  disabled={disabled || selectedRole === "IP"}
                />
              ) : (
                <VendorCode
                  disabled={disabled}
                  formState={newFormState}
                  changeHandler={changeHandler}
                  bordered={true}
                  user={newFormState?.vendor_Code?.Vendor_Code || ""}
                />
              )}
            </FormControl>
          </Grid>
          {(newFormState?.vendor_Code?.designation!==undefined && newFormState?.vendor_Code?.designation!==null && newFormState?.vendor_Code?.designation!=="") && 
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <FormControl fullWidth size="small">
              <Typography style={{ color: "black" }}>Employee Designation: </Typography>
              {disabled || selectedRole === "IP" ? (
                <TextField
                  fullWidth
                  size="small"
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 30,
                    },
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  id="outlined-basic"
                  name=""
                  value={newFormState?.vendor_Code?.designation}
                  variant="outlined"
                  disabled={disabled || selectedRole === "IP"}
                />
              ) : (
                <VendorCode
                  disabled={disabled}
                  formState={newFormState}
                  changeHandler={changeHandler}
                  bordered={true}
                  user={newFormState?.vendor_Code?.Vendor_Code || ""}
                />
              )}
            </FormControl>
          </Grid>}
          {(newFormState?.vendor_Code?.department!==undefined && newFormState?.vendor_Code?.department!==null && newFormState?.vendor_Code?.department!=="") && 
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <FormControl fullWidth size="small">
              <Typography style={{ color: "black" }}>Employee Department: </Typography>
              {disabled || selectedRole === "IP" ? (
                <TextField
                  fullWidth
                  size="small"
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 30,
                    },
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  id="outlined-basic"
                  name=""
                  value={newFormState?.vendor_Code?.department}
                  variant="outlined"
                  disabled={disabled || selectedRole === "IP"}
                />
              ) : (
                <VendorCode
                  disabled={disabled}
                  formState={newFormState}
                  changeHandler={changeHandler}
                  bordered={true}
                  user={newFormState?.vendor_Code?.Vendor_Code || ""}
                />
              )}
            </FormControl>
          </Grid>}
        </>
      )}
      {selectedRole === "Logistic" ||
      showVendorAndPO_NumberForImport() ||
      ((selectedRole === "TaxTeam" ||
        selectedRole === "Loam Approver" ||
        selectedRole === "IR" ||
        selectedRole === "I2P Initiator" ||
        selectedRole === "Buyer" ||
        (selectedRole === "IP" && fields && !newFormState?.isHR) ||
        (selectedRole === "IP" && !edit && disabled && !newFormState?.isHR) ||
        (selectedRole === "IP" &&
          newFormState?.isVPPayment &&
          !disabled &&
          !newFormState?.isHR)) &&
        poBasedState === "PO") ? (
        <>
          {/* Vendor */}
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <Typography style={{ color: "black" }}>
              <span className={classes.asterisk}>*</span>
              Vendor Code:
            </Typography>
            <TextField
              fullWidth
              size="small"
              disabled={true}
              // disabled={newFormState?.vendor_Code != null ? true : false}
              sx={{
                "& .MuiInputBase-root": {
                  height: 30,
                },
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-basic"
              variant="outlined"
              name="vendor_Code"
              required={newFormState?.vendor_Code === ""}
              value={newFormState?.vendor_Code}
              onChange={changeHandler}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <Typography style={{ color: "black" }}>
              <span className={classes.asterisk}>*</span>
              Vendor Name:
            </Typography>
            <TextField
              fullWidth
              size="small"
              disabled={true}
              // disabled={newFormState?.vendor_Code != null ? true : false}
              sx={{
                "& .MuiInputBase-root": {
                  height: 30,
                },
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-basic"
              variant="outlined"
              name="vendor_Code"
              required={newFormState?.vendor_Name === ""}
              value={VendorName}
              onChange={changeHandler}
            />
          </Grid>
        </>
      ) : (
        ""
      )}
      {/* Invoice Type */}
      {selectedRole === "Import" ||
      (selectedRole === "Loam Approver" &&
        poBasedState === "Non-PO" &&
        !newFormState?.isPCDV) ||
      (selectedRole === "Department Coordinator" &&
        poBasedState === "Non-PO" &&
        !newFormState?.isPCDV) ||
      (selectedRole === "TaxTeam" && poBasedState === "Non-PO") ||
      // (selectedRole === "IP" &&

      //   !edit &&
      //   disabled) ||
      (selectedRole === "Buyer" && poBasedState === "Non-PO") ||
      (selectedRole === "IP" &&
        disabled &&
        !edit &&
        !newFormState?.isHR &&
        (newFormState?.isImport ||
          (!newFormState?.pO_Based && !newFormState?.isPCDV))) ||
      (selectedRole === "IR" && poBasedState === "Non-PO") ? (
        <Grid
          item
          xs={12}
          sm={12}
          md={alignForAttachment ? 6 : 3}
          lg={alignForAttachment ? 6 : 3}
        >
          <FormControl fullWidth size="small">
            <Typography style={{ color: "black" }}>
              <span className={classes.asterisk}>*</span> Invoice Type:
            </Typography>
            <Autocomplete
              sx={{
                "& .MuiInputBase-root": {
                  height: "30px",
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                },
                "& .MuiInputBase-input": {
                  marginTop: "-4px", // Adjust this value to move the text up
                  fontSize: 15,
                },
              }}
              id="submitter_role"
              options={multipleData?.invoice_Type || []}
              // defaultValue={[multipleData?.invoice_Type[0]]}
              size="small"
              disabled={disabled}
              value={{
                ReferenceCode:
                  newFormState?.invoice_Type ||
                  newFormState?.invoice_Type ||
                  "",
              }}
              // value={formState.invoice_Payment}
              getOptionLabel={(option) =>
                (option !== "" && `${option?.ReferenceCode}`) || ""
              }
              // loading={rolesLoading}
              onChange={(event, newValue) => {
                const e = {
                  target: {
                    name: "invoice_Type",
                    value: newValue?.ReferenceCode,
                  },
                };

                changeHandler(e);
              }}
              renderInput={(params) => (
                <TextField {...params} type="text" name="" label="" required />
              )}
            />
            {/* <Select
              size="small"
              // labelId="demo-simple-select-label"
              value={newFormState?.invoice_Type}
              name="invoice_Type"
              id="demo-simple-select"
              onChange={changeHandler}
              inputProps={{ "aria-label": "Without label" }}
              disabled={disabled}
              displayEmpty
              className={classes.selectEmpty}
            >
              <MenuItem value="" disabled>
                Select a Value
              </MenuItem>
              {invoiceType.map((item) => {
                return <MenuItem value={item.role}>{item.role}</MenuItem>;
              })}
            </Select> */}
          </FormControl>
        </Grid>
      ) : (
        ""
      )}

      {/* Document type */}
      {
        // (selectedRole === "IP" && newFormState?.isImport && disabled && !edit) ||
        !newFormState?.pO_Based &&
        selectedRole === "IP" &&
        // poBasedState === "Non-PO" &&
        !edit &&
        !disabled ? (
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <FormControl fullWidth size="small">
              <Typography style={{ color: "black" }}>
                <span className={classes.asterisk}>*</span>Document Type:
              </Typography>
              <Autocomplete
                sx={{
                  "& .MuiInputBase-root": {
                    height: "30px",
                    textAlign: "center",
                    display: "flex",
                    alignItems: "center",
                  },
                  "& .MuiInputBase-input": {
                    marginTop: "-4px", // Adjust this value to move the text up
                    fontSize: 15,
                  },
                }}
                id="submitter_role"
                options={multipleData?.document_Type || []}
                // defaultValue={[multipleData?.document_Type[0]]}
                size="small"
                disabled={
                  disabled ||
                  status === "SendToIPFromSupervisor" ||
                  status === "SendToReviewerFromSupervisor"
                    ? true
                    : ""
                }
                value={{
                  ReferenceCode:
                    newFormState?.document_Type ||
                    newFormState?.document_Type ||
                    "",
                }}
                // value={formState.invoice_Payment}
                getOptionLabel={(option) =>
                  (option !== "" && `${option?.ReferenceCode}`) || ""
                }
                // loading={rolesLoading}
                onChange={(event, newValue) => {
                  const e = {
                    target: {
                      name: "document_Type",
                      value: newValue?.ReferenceCode,
                    },
                  };

                  changeHandler(e);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    type="text"
                    name=""
                    label=""
                    required
                  />
                )}
              />
              {/* <Select
              size="small"
              // labelId="demo-simple-select-label"
              value={newFormState?.invoice_Type}
              name="invoice_Type"
              id="demo-simple-select"
              onChange={changeHandler}
              inputProps={{ "aria-label": "Without label" }}
              disabled={disabled}
              displayEmpty
              className={classes.selectEmpty}
            >
              <MenuItem value="" disabled>
                Select a Value
              </MenuItem>
              {invoiceType.map((item) => {
                return <MenuItem value={item.role}>{item.role}</MenuItem>;
              })}
            </Select> */}
            </FormControl>
          </Grid>
        ) : (
          ""
        )
      }
      {(selectedRole === "IR" ||
        selectedRole === "Department Coordinator" ||
        selectedRole === "Loam Approver" ||
        selectedRole === "Import" ||
        selectedRole === "I2P Initiator" ||
        selectedRole === "Logistic" ||
        selectedRole === "TaxTeam" ||
        selectedRole === "Buyer" ||
        (selectedRole === "IP" && !edit && !hide)) && (
        <>
          {/* Invoice Number */}
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <Typography style={{ color: "black" }}>
              <span className={classes.asterisk}>*</span>
              {newFormState?.isHR
                ? "Reference Number "
                : "Invoice Number "}{" "}
            </Typography>

            <TextField
              fullWidth
              size="small"
              name="invoice_No"
              value={newFormState?.invoice_No}
              sx={{
                "& .MuiInputBase-root": {
                  height: 30,
                },
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-basic"
              variant="outlined"
              // disabled={disabled || newFormState?.isPCDV}
              disabled={true}
              required
              onChange={changeHandler}
              inputProps={{ maxLength: 16 }}
            />
          </Grid>
          {/* Invoice Date */}
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
            style={{ paddingRight: "18px" }}
          >
            <Typography style={{ color: "black" }}>
              <span className={classes.asterisk}>*</span>Invoice Date:
            </Typography>
            <input
              className={classes.inputField}
              name="invoice_Date"
              type="date"
              max="9999-12-31"
              // disabled={disabled}
              disabled={true}
              style={dateStyle}
              value={newFormState?.invoice_Date}
              onChange={changeHandler}
              onInput={(newValue) => {
                isOldDateValidate(
                  formatDateTimeForBackend(newValue),
                  setOpenInvalidWarningDate,
                  setInvalidWarningDateState,
                  setNewFormState
                );
                setNewFormState((formState) => ({
                  ...formState,
                  invoice_Date: formatDateTimeForBackend(newValue),
                }));
                isFutureDate(
                  formatDateTimeForBackend(newValue),
                  setNewFormState,
                  "invoice_Date"
                );
              }}
            />
          </Grid>

          {/* Invoice Description */}
        </>
      )}
      {((selectedRole === "Department Coordinator" &&
        poBasedState === "Non-PO" &&
        !newFormState?.isPCDV) ||
        (selectedRole === "TaxTeam" && poBasedState === "Non-PO") ||
        selectedRole === "TaxTeam" ||
        newFormState?.invoice_Type === "DN" ||
        (selectedRole === "IP" &&
          newFormState?.invoice_Type !== "ERF" &&
          // poBasedState === "Non-PO" &&
          !newFormState?.isPCDV &&
          !edit &&
          disabled) ||
        selectedRole === "Logistic" ||
        (selectedRole === "Loam Approver" && poBasedState === "Non-PO")) && (
        // !newFormState?.isPCDV
        <>
          {(newFormState?.invoice_Type !== "DES" || user?.Location !== "1") && (
            <Grid
              item
              xs={12}
              sm={12}
              md={alignForAttachment ? 6 : 3}
              lg={alignForAttachment ? 6 : 3}
            >
              <Typography style={{ color: "black" }}>
                <span className={classes.asterisk}>*</span>
                Days To Sales Tax Lapse:{" "}
              </Typography>
              <TextField
                fullWidth
                name=""
                type="number"
                value={newFormState?.daysto_sale_taxlapse}
                onChange={changeHandler}
                disabled={disabled}
                size="small"
                sx={{
                  "& .MuiInputBase-root": {
                    height: 30,
                  },
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                id="outlined-basic"
                variant="outlined"
              />
            </Grid>
          )}

          {/* {(!newFormState?.isHR && user?.Location !== "1") ? (
            <Grid
              item
              xs={12}
              sm={12}
              md={alignForAttachment ? 6 : 3}
              lg={alignForAttachment ? 6 : 3}
            >
              <Typography style={{ color: "black" }}>
                <span className={classes.asterisk}>*</span>Courier Tracking #:
              </Typography>
              <TextField
                fullWidth
                name="courier_tracking_No"
                type="number"
                value={Number(newFormState?.courier_Tracking_No)}
                onChange={changeHandler}
                disabled={disabled}
                size="small"
                sx={{
                  // width: "70%",
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                id="outlined-basic"
                variant="outlined"
              />
            </Grid>
          ) : null} */}
        </>
      )}
      {(selectedRole === "IR" ||
        selectedRole === "Department Coordinator" ||
        selectedRole === "Loam Approver" ||
        selectedRole === "Import" ||
        selectedRole === "I2P Initiator" ||
        selectedRole === "HR" ||
        selectedRole === "TaxTeam" ||
        selectedRole === "Logistic" ||
        selectedRole === "Buyer" ||
        // (selectedRole === "IP" && fields) ||
        (selectedRole === "IP" && !edit && !hide) ||
        (selectedRole === "IP" && newFormState?.isHR)) && (
        <>
          {/* Invoice Amount */}
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <Typography style={{ color: "black" }}>
              <span className={classes.asterisk}>*</span>
              Invoice Amount:
            </Typography>
            <TextField
              fullWidth
              size="small"
              sx={{
                "& .MuiInputBase-root": {
                  height: 30,
                },
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-basic"
              variant="outlined"
              type="text"
              pattern="[0-9]*"
              min={1}
              name="invoice_Amount"
              // value={newFormState?.invoice_Amount}
              value={newFormState.invoice_Amount_formatted}
              disabled={disabled}
              required
              InputProps={{
                inputProps: {
                  min: 0,
                  step: 0.00001,
                  inputMode: "numeric",
                },
              }}
              onChange={changeHandler}
            />
          </Grid>
        </>
      )}
      {(selectedRole === "IR" ||
        selectedRole === "Department Coordinator" ||
        selectedRole === "Loam Approver" ||
        selectedRole === "Import" ||
        selectedRole === "I2P Initiator" ||
        selectedRole === "Logistic" ||
        selectedRole === "TaxTeam" ||
        selectedRole === "Buyer" ||
        (selectedRole === "IP" && !edit && newFormState?.invoice_Desc) ||
        (selectedRole === "IP" && fields && newFormState?.invoice_Desc)) && (
        <Grid
          item
          xs={12}
          sm={12}
          md={alignForAttachment ? 6 : 3}
          lg={alignForAttachment ? 6 : 3}
        >
          <Typography style={{ color: "black" }}>
            <span className={classes.asterisk}>*</span> Invoice Description:
          </Typography>
          <TextField
            fullWidth
            size="small"
            sx={{
              "& .MuiInputBase-root": {
                height: 30,
              },
              "& legend": { display: "none" },
              "& fieldset": { top: 0 },
            }}
            id="outlined-basic"
            name="invoice_Desc"
            value={newFormState?.invoice_Desc}
            variant="outlined"
            disabled={status === "SendToIPFromSupervisor" ? true : disabled}
            required
            onChange={changeHandler}
            inputProps={{ maxLength: 50 }}
            FormHelperTextProps={{
              className: classes.helperText,
            }}
            error={/[!@#$%^&*()_+={}\[\]:;"'<>,?/~\\-`]/.test(
              newFormState?.invoice_Desc
            )}
            helperText={
              /[!@#$%^&*()_+={}\[\]:;"'<>,?/~\\-`]/.test(
                newFormState?.invoice_Desc
              )
                ? "Can be a word or number without any special character!"
                : null
            }
          />
        </Grid>
      )}
      {(selectedRole === "HR" || selectedRole === "Line Manager") && (
        <>
          {/* Category */}

          <Grid item xs={12} sm={12} md={6} lg={6}>
            <FormControl fullWidth size="small">
              <Typography style={{ color: "black" }}>
                <span className={classes.asterisk}>*</span>Category:
              </Typography>

              <Select
                size="small"
                // labelId="demo-simple-select-label"
                value={newFormState?.invoiceCategory}
                id="demo-simple-select"
                name="invoiceCategory"
                onChange={changeHandler}
                style={{ height: 30 }}
                inputProps={{ "aria-label": "Without label" }}
                displayEmpty
                className={classes.selectEmpty}
                disabled={disabled}
              >
                <MenuItem value="" disabled>
                  Select a Value
                </MenuItem>
                {category.map((item) => {
                  return <MenuItem value={item.role}>{item.role}</MenuItem>;
                })}
              </Select>
            </FormControl>
          </Grid>

          {/* Reference */}
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Typography style={{ color: "black" }}>
              <span className={classes.asterisk}>*</span>Reference Number:
            </Typography>
            <TextField
              fullWidth
              size="small"
              name="invoice_No"
              value={newFormState?.invoice_No}
              onChange={changeHandler}
              sx={{
                "& .MuiInputBase-root": {
                  height: 30,
                },
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-basic"
              variant="outlined"
              disabled={disabled}
            />
          </Grid>
          {/* Invoice amount */}
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <Typography style={{ color: "black" }}>
              <span className={classes.asterisk}>*</span>
              Invoice Amount:
            </Typography>
            <TextField
              fullWidth
              size="small"
              sx={{
                "& .MuiInputBase-root": {
                  height: 30,
                },
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-basic"
              variant="outlined"
              type="text"
              pattern="[0-9]*"
              min={1}
              name="invoice_Amount"
              // value={newFormState?.invoice_Amount}
              value={newFormState.invoice_Amount_formatted}
              disabled={disabled}
              required
              InputProps={{
                inputProps: {
                  min: 0,
                  step: 0.00001,
                  inputMode: "numeric",
                },
              }}
              onChange={changeHandler}
            />
          </Grid>
          {/* Description */}
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Typography style={{ color: "black" }}>
              <span className={classes.asterisk}>*</span>Invoice Description:
            </Typography>
            <TextField
              fullWidth
              size="small"
              sx={{
                "& .MuiInputBase-root": {
                  height: 30,
                },
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              value={newFormState?.invoice_Desc}
              onChange={changeHandler}
              id="outlined-basic"
              variant="outlined"
              disabled={
                disabled ||
                status === "SendToIPFromSupervisor" ||
                status === "SendToReviewerFromSupervisor"
                  ? true
                  : ""
              }
            />
          </Grid>
          {/* Date */}
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            style={{ paddingRight: "18px" }}
          >
            <Typography style={{ color: "black" }}>
              <span className={classes.asterisk}>*</span>Invoice Date:
            </Typography>
            <input
              className={classes.inputField}
              name="invoice_Date"
              type="date"
              max="9999-12-31"
              disabled={disabled}
              style={dateStyle}
              onChange={changeHandler}
              value={newFormState?.invoice_Date || ""}
              onInput={(newValue) => {
                isOldDateValidate(
                  formatDateTimeForBackend(newValue),
                  setOpenInvalidWarningDate,
                  setInvalidWarningDateState,
                  setNewFormState
                );
                setNewFormState((formState) => ({
                  ...formState,
                  invoice_Date: formatDateTimeForBackend(newValue),
                }));
                isFutureDate(
                  formatDateTimeForBackend(newValue),
                  setNewFormState,
                  "invoice_Date"
                );
              }}
            />
            {/*  <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                // value={value}
                // onChange={(newValue) => {
                //   setValue(newValue);
                // }}
                value=" "
                error={false}
                renderInput={(params) => (
                  <TextField
                    fullWidth
                    size="small"
                    id="outlined-basic"
                    label="Outlined"
                    variant="outlined"
                    {...params}
                    error={false}
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                  />
                )}
              />
                  </LocalizationProvider>*/}
          </Grid>
          {(newFormState?.invoiceCategory === "Final Settlement – Norma" ||
            newFormState?.invoiceCategory ===
              "Final Settlement – Death cas") && (
            <>
              {/* FS DOC Date */}
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                style={{ paddingRight: "18px" }}
              >
                <Typography style={{ color: "black" }}>
                  <span className={classes.asterisk}>*</span>
                  FS DOC Date:{" "}
                </Typography>
                <input
                  className={classes.inputField}
                  name="fsDocumentDate"
                  type="date"
                  max="9999-12-31"
                  onChange={changeHandler}
                  value={newFormState?.fsDocumentDate || ""}
                  disabled={disabled}
                  style={{ height: 13 }}
                  onInput={(newValue) => {
                    setNewFormState((formState) => ({
                      ...formState,
                      fsDocumentDate: formatDateTimeForBackend(newValue),
                    }));
                  }}
                />

                {/*  <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    // value={value}
                    // onChange={(newValue) => {
                    //   setValue(newValue);
                    // }}
                    value=" "
                    error={false}
                    renderInput={(params) => (
                      <TextField
                        fullWidth
                        size="small"
                        id="outlined-basic"
                        variant="outlined"
                        onChange={changeHandler}
                        value={newFormState?.fs_Doc_Date || ""}
                        {...params}
                        error={false}
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                      />
                    )}
                  />
                      </LocalizationProvider>*/}
              </Grid>

              {/* Final Settlement Doc */}
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Typography style={{ color: "black" }}>
                  <span className={classes.asterisk}>*</span>
                  Final Settlement Doc:{" "}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  name="fsDocumentNumber"
                  value={newFormState?.fsDocumentNumber}
                  onChange={changeHandler}
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 30,
                    },
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  id="outlined-basic"
                  variant="outlined"
                  disabled={disabled}
                />
              </Grid>
            </>
          )}
        </>
      )}

      {/* {((selectedRole === "IP" && !disabled && !edit) || fields) && ( */}
      {((selectedRole === "IP" && !disabled && !edit) ||
        (selectedRole === "IP" && fields)) && (
        <>
          {/* Posting Date */}
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
            style={{ paddingRight: "18px" }}
          >
            <Typography style={{ color: "black" }}>
              <span className={classes.asterisk}>*</span>
              Posting Date:
            </Typography>

            {/*  <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                shouldDisableDate={isAboveToday}
                // value={value}
                onChange={(newValue) => {
                  isOldDateValidate(
                    formatDateTimeForBackend(newValue),
                    setOpenInvalidWarningDate,
                    setNewFormState
                  );
                  setNewFormState((formState) => ({
                    ...formState,
                    posting_Date: formatDateTimeForBackend(newValue),
                  }));
                  isFutureDate(
                    formatDateTimeForBackend(newValue),
                    setNewFormState,
                    "posting_Date"
                  );
                }}
                disabled={disabled || edit}
                value={newFormState?.posting_Date}
                error={false}
                renderInput={(params) => (
                  <TextField
                    fullWidth
                    size="small"
                    name="posting_Date"
                    id="outlined-basic"
                    label="Outlined"
                    variant="outlined"
                    onChange={changeHandler}
                    required
                    {...params}
                    error={false}
                    sx={{
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                  />
                )}
              />
            </LocalizationProvider>
                  */}
            <input
              className={classes.inputField}
              name="posting_Date"
              type="date"
              max="9999-12-31"
              disabled={status === "SendToIPFromSupervisor" ? true : disabled}
              style={{
                color: disabled ? "#B4B4B4" : null,
                backgroundColor: disabled ? "white" : null,
                height: 13,
              }}
              onChange={changeHandler}
              onInput={(newValue) => {
                isOldDateValidate(
                  formatDateTimeForBackend(newValue),
                  setOpenInvalidWarningDate,
                  setInvalidWarningDateState,
                  setNewFormState
                );
                setNewFormState((formState) => ({
                  ...formState,
                  posting_Date: formatDateTimeForBackend(newValue),
                }));
                isFutureDate(
                  formatDateTimeForBackend(newValue),
                  setNewFormState,
                  "posting_Date"
                );
              }}
              value={newFormState?.posting_Date}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <Typography style={{ color: "black" }}>
              <span className={classes.asterisk}>*</span>
              Currency:
            </Typography>
            <Autocomplete
              sx={{
                "& .MuiInputBase-root": {
                  height: "30px",
                  textAlign: "center",
                  display: "flex",
                  alignItems: "center",
                },
                "& .MuiInputBase-input": {
                  marginTop: "-4px", // Adjust this value to move the text up
                  fontSize: 15,
                },
              }}
              id="submitter_role"
              options={multipleData?.currency || []}
              defaultValue={[multipleData?.currency[0]]}
              size="small"
              disabled={
                status === "SendToIPFromSupervisor" ? true : disabled || edit
              }
              value={{
                ReferenceCode:
                  newFormState?.currency || newFormState?.Currency || "",
              }}
              // value={formState.invoice_Payment}
              getOptionLabel={(option) =>
                (option !== "" && `${option?.ReferenceCode}`) || ""
              }
              // loading={rolesLoading}
              onChange={(event, newValue) => {
                const e = {
                  target: {
                    name: "currency",
                    value: newValue?.ReferenceCode,
                  },
                };

                changeHandler(e);
              }}
              renderInput={(params) => (
                <TextField {...params} type="text" name="" label="" required />
              )}
            />
          </Grid>
        </>
      )}
      {/* {selectedRole === "IP" &&
        !edit &&
        !disabled &&
        invoiceEdit === "true" && (
          <>
            <Grid
              item
              xs={12}
              sm={12}
              md={alignForAttachment ? 6 : 3}
              lg={alignForAttachment ? 6 : 3}
            >
              <Typography style={{ color: "black" }}>
                Attach Invoice:
              </Typography>
              <TextField
                fullWidth
                size="small"
                sx={{
                  "& .MuiInputBase-root": {
                    height: 30,
                  },
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                id="outlined-basic"
                variant="outlined"
            
                disabled={
                  disabled ||
                  status === "SendToIPFromSupervisor" ||
                  status === "SendToReviewerFromSupervisor"
                    ? true
                    : ""
                }
        
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <input
                        ref={invoice_attachmentRef}
                        type="file"
                        accept=".png, .jpg, .jpeg, .pdf"
                        name="invoice_attachment"
                        onChange={(e) =>
                          uploadFile_v1(
                            e,
                            setNewFormState,
                            setAttachInvoiceLoading,
                            "invoice_attachment",
                            setAttchmentFile_UI,
                            invoice_attachmentRef,
                            setAttachmentURLList,
                            setAttachmentURL,
                            attachmentURLList,
                            newFormState.invoice_attachment,
                            setDocError,
                            setAttachError,
                            setAlertMessage,
                            invoicePayload,
                            { roleName: selectedRole },
                            false,
                            () => {},
                            setSuccessMessage
                          )
                        }
                        disabled={
                          disabled ||
                          status === "SendToIPFromSupervisor" ||
                          status === "SendToReviewerFromSupervisor"
                            ? true
                            : ""
                        }
                        style={{ width: "209px" }}
                      />
                    </InputAdornment>
                  ),
                }}
                FormHelperTextProps={{
                  className: classes.helperText,
                }}
            
              />
              {newFormState?.invoice_attachment && (
                <>
                  <IconButton
                    size="small"
                    onClick={() => {
                      downloadAttachments(
                        newFormState?.invoice_attachment?.path
                      );
                    }}
                  >
                    <Download color="secondary" />{" "}
                  </IconButton>
              

                  <>
                    <IconButton
                      style={{
                        fontSize: "12px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        const allowedExtensions = [
                          ".png",
                          ".pdf",
                          ".jpg",
                          ".jpeg",
                          ".PNG",
                          ".JPG",
                          ".JPEG",
                          ".PNG",
                          ".PDF",
                        ];
                        const fileExtension =
                          "." +
                          newFormState?.invoice_attachment?.path
                            ?.split("\\")
                            [
                              newFormState?.invoice_attachment?.path?.split(
                                "\\"
                              ).length - 1
                            ].split(".")
                            .pop();
                        if (allowedExtensions.includes(fileExtension)) {
                          showAttachmentsHandler(
                            newFormState?.invoice_attachment
                          );
                        } else {
                          showAttachmentsHandler(
                            newFormState?.invoice_attachment
                          );
                          window.open(
                            `${process.env.REACT_APP_API_URL}/${newFormState?.invoice_attachment?.path}`,
                            "_blank"
                          );
                        }
                      }}
                      s
                    >
                      <span style={{ fontSize: "14px" }}>
                        {
                          newFormState?.invoice_attachment?.path?.split("\\")[
                            newFormState?.invoice_attachment?.path?.split("\\")
                              .length - 1
                          ]
                        }
                      </span>
                    </IconButton>
                  </>
                </>
              )}
            </Grid>
          </>
        )} */}
      {(selectedRole === "Import" ||
        selectedRole === "I2P Initiator" ||
        selectedRole === "Department Coordinator" ||
        selectedRole === "Loam Approver" ||
        selectedRole === "IR" ||
        selectedRole === "HR" ||
        selectedRole === "Line Manager" ||
        selectedRole === "EFDV Initiator" ||
        selectedRole === "TaxTeam" ||
        selectedRole === "Logistic" ||
        selectedRole === "Buyer" ||
        (selectedRole === "IP" && invoiceEdit === "true")) && (
        <>
          {/* Additional Document */}
          {!disabled && (
            <Grid
              item
              xs={12}
              sm={12}
              md={alignForAttachment ? 6 : 3}
              lg={alignForAttachment ? 6 : 3}
            >
              <Typography style={{ color: "black" }}>
                Additional Document:
                {/* <span className={classes.asterisk}>*</span> */}
              </Typography>
              <TextField
                fullWidth
                disabled={disabled}
                size="small"
                sx={{
                  "& .MuiInputBase-root": {
                    height: 30,
                  },
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                id="outlined-basic"
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <input
                        ref={additionalAttachmentRef}
                        type="file"
                        // accept="application/pdf, image/png , image/jpg , image/jpeg "
                        name="additionalDocIds"
                        disabled={
                          status === "SendToIPFromSupervisor" ? false : disabled
                        }
                        onChange={(e) =>
                          uploadAdditioalDocumentFile(
                            e,
                            setNewFormState,
                            setAttachInvoiceLoading,
                            "additionalDocIds",
                            additionalAttachmentRef,
                            setDocError,
                            setAttachError,
                            setAlertMessage,
                            invoicePayload,
                            { roleName: selectedRole },
                            false,
                            () => {},
                            setSuccessMessage
                          )
                        }
                        style={{ width: "209px" }}
                        multiple
                      />
                    </InputAdornment>
                  ),
                }}
                // FormHelperTextProps={{
                //   className: classes.helperText,
                // }}
                // error={docError ? true : false}
                // helperText={docError ? `${docError}` : null}
              />
              {newFormState?.additionalDocIds?.length > 0 &&
                newFormState?.additionalDocIds.map((f, index) => {
                  const s = f?.path?.split("\\");
                  const ss = s[s.length - 1];
                  return (
                    <div>
                      {f?.path !== "" ? (
                        <>
                          {/* {!disabled && (
                        <Delete
                          color="danger"
                          style={{
                            cursor: "pointer",
                          }}
                          fontSize="small"
                          onClick={() => {
                            setOpenWarningBox(true);

                            setCurrentStateForDeleteion({
                              ss,
                              f,
                            });
                          }}
                        />
                      )} */}
                          <IconButton
                            size="small"
                            disabled={f?.role_Name !== selectedRole}
                            onClick={() => {
                              setCurrentStateForDeleteion(f);
                              setOpenWarningBox(true);
                              setWarningFlag(true);
                            }}
                          >
                            <Delete
                              titleAccess="Delete"
                              color="danger"
                              fontSize="small"
                              style={{
                                color:
                                  // disable ||
                                  f?.role_Name !== selectedRole ? "gray" : "",
                              }}
                            />
                          </IconButton>

                          <IconButton
                            size="small"
                            onClick={() => {
                              downloadAttachments(f?.path);
                            }}
                          >
                            <Download color="secondary" />{" "}
                          </IconButton>
                          <IconButton
                            size="small"
                            onClick={() => {
                              const allowedExtensions = [
                                ".png",
                                ".pdf",
                                ".jpg",
                                ".jpeg",
                                ".PNG",
                                ".JPG",
                                ".JPEG",
                                ".PNG",
                                ".PDF",
                              ];
                              const fileExtension = "." + ss.split(".").pop();
                              if (allowedExtensions.includes(fileExtension)) {
                                setAttachmentURL(f);
                              } else {
                                setAttachmentURL(f);

                                window.open(
                                  `${process.env.REACT_APP_API_URL}/${f.path}`,
                                  "_blank"
                                );
                              }
                            }}
                          >
                            <span style={{ fontSize: "12px" }}>{ss}</span>
                          </IconButton>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  );
                })}
            </Grid>
          )}
        </>
      )}
      {(selectedRole === "IR" ||
        selectedRole === "I2P Initiator" ||
        selectedRole === "Loam Approver" ||
        selectedRole === "TaxTeam" ||
        selectedRole === "Import" ||
        selectedRole === "Buyer" ||
        (selectedRole === "IP" && fields && !newFormState?.isHR) ||
        (selectedRole === "IP" && !edit && !newFormState?.isHR)) && (
        <>
          {/* PO Number */}
          {((selectedRole === "IR" ||
            (selectedRole === "IP" && disabled) ||
            (selectedRole === "Loam Approver" && !newFormState?.isPCDV) ||
            selectedRole === "Buyer" ||
            selectedRole === "TaxTeam" ||
            selectedRole === "I2P Initiator") &&
            (poBasedState === "PO" || newFormState?.pO_Based)) ||
          showVendorAndPO_NumberForImport() ? (
            <>
              <Grid
                item
                xs={12}
                sm={12}
                md={alignForAttachment ? 6 : 3}
                lg={alignForAttachment ? 6 : 3}
              >
                <Typography style={{ color: "black" }}>
                  <span className={classes.asterisk}>*</span>
                  PO Number:
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 30,
                    },
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  id="outlined-basic"
                  variant="outlined"
                  name="pO_No"
                  disabled={disabled}
                  required
                  value={newFormState?.pO_No}
                  onChange={changeHandler}
                />
              </Grid>
<Grid container spacing={2} marginY={3}>
{( formState?.po_Date !== "" ) && 
<Grid
item
xs={12}
sm={12}
md={alignForAttachment ? 6 : 3}
lg={alignForAttachment ? 6 : 3}
style={{ paddingRight: "18px" }}
>
<Typography style={{ color: "black" }}>
  <span className={classes.asterisk}>*</span>PO Date:
</Typography>
<input
  className={classes.inputField}
  name="PO_date"
  type="text"
  // max="9999-12-31"
  // disabled={disabled}
  disabled={true}
  style={dateStyle}
  // value={newFormState?.invoicePORef_List[0]?.doc_Date}
  value={PODate}
  onChange={changeHandler}
/>
</Grid>
}

{( formState?.plant_Code !== ""   ) && 
<Grid
item
xs={12}
sm={12}
md={alignForAttachment ? 6 : 3}
lg={alignForAttachment ? 6 : 3}
style={{ paddingRight: "18px" }}
>
<Typography style={{ color: "black" }}>
  <span className={classes.asterisk}>*</span>Plant Code:
</Typography>
<input
  className={classes.inputField}
  name="plant_Code"
  type="text"
  // max="9999-12-31"
  // disabled={disabled}
  disabled={true}
  style={dateStyle}
  // value={newFormState?.invoicePORef_List[0]?.doc_Date}
  value={formState?.plant_Code}
  onChange={changeHandler}
/>
</Grid>
}
</Grid>
            </>
          ) : (
            ""
          )}
        </>
      )}

{
  (selectedRole === "Department Coordinator" || selectedRole === "IR" ||
    selectedRole === "I2P Initiator" ||
    selectedRole === "Loam Approver" ||
    selectedRole === "TaxTeam" ||
    selectedRole === "Import" ||
    selectedRole === "Reviewer" ||
    selectedRole === "Buyer" ) &&

  (
    <Grid
item
xs={12}
sm={12}
md={alignForAttachment ? 6 : 3}
lg={alignForAttachment ? 6 : 3}
style={{ paddingRight: "18px" }}
>
  <Typography style={{ color: "black" }}>
                                    
                                    Due Date:

                                    
                                  </Typography>
                                  <TextField
                                    fullWidth
                                    size="small"
                                    sx={{
                                      "& .MuiInputBase-root": {
                                        height: 30,
                                      },
                                      input: { color: "black !important" },
                                      "& legend": { display: "none" },
                                      "& fieldset": { top: 0 },
                                    }}
                                    id="outlined-basic"
                                    variant="outlined"
                                    name="due_Date"
                                    // required={formState?.delv_Note_No ? false : true}
                                 
                                    value={typeof(formState?.due_Date) == "string" && moment(formState?.due_Date).format("YYYY-MM-DD")?.split("-")?.reverse()?.join("/") || ""}
                                    onChange={changeHandler}
                                    disabled={true}
                                  />
                                  
</Grid>
  )
}
   
      {/* {selectedRole === "IP" && */}
      {/* // poBasedState === "Non-PO" &&
        // !newFormState?.isPCDV && */}
      {/* !edit &&
        disabled && (
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <Typography style={{ color: "black" }}>
              Days To Sales Tax Lapse{" "} */}
      {/*<span className={classes.asterisk}>*</span>*/}
      {/* </Typography>
            <TextField
              fullWidth
              name=""
              type="number"
              value={newFormState?.daysto_sale_taxlapse || ""}
              onChange={changeHandler}
              disabled={disabled}
              size="small"
              sx={{
                // width: "70%",
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-basic"
              variant="outlined"
            />
          </Grid>
        )} */}

      {(((selectedRole === "IR" ||
        selectedRole === "I2P Initiator" ||
        (selectedRole === "TaxTeam" && newFormState?.isDeptCordinator) ||
        (selectedRole === "IP" && newFormState?.dept_coordinator) ||
        (selectedRole === "Loam Approver" && !newFormState.isImport) ||
        (selectedRole === "Department Coordinator" &&
          newFormState?.dept_coordinator)) &&
        poBasedState === "Non-PO") ||
        selectedRole === "EFDV Initiator") && (
        <>
          {/* Department Coordinator */}

          {!newFormState?.isImport &&
            !newFormState?.isVPPayment &&
            !edit &&
            disabled && newFormState?.dept_coordinator !== "" && (
              <Grid
                item
                xs={12}
                sm={12}
                md={alignForAttachment ? 6 : 3}
                lg={alignForAttachment ? 6 : 3}
              >
                <FormControl fullWidth size="small">
                  <UsersByRole
                    label="Department Coordinator"
                    apiString="Department Coordinator"
                    name="dept_coordinator"
                    formState={newFormState}
                    changeHandler={changeHandler}
                    required={true}
                    disabled={disabled}
                    classes={classes}
                  />
                </FormControl>
              </Grid>
            )}
        </>
      )}
      {/* Tax Team */}
      {/* {!newFormState?.skipTaxStep && !newFormState?.isVppayment  && newFormState?.invoice_Type !== "ERF" && (
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={alignForAttachment ? 6 : 3}
                    lg={alignForAttachment ? 6 : 3}
                  >
                    <FormControl fullWidth size="small">
                      <UsersByRole
                        label="Tax Team"
                        apiString="Tax Team"
                        name="taxTeam"
                        formState={newFormState}
                        changeHandler={changeHandler}
                        required={true}
                        classes={classes}
                        disabled={disabled}
                      />
                    </FormControl>
                  </Grid>
                )} */}
      {(selectedRole === "IR" ||
        selectedRole === "Logistic" ||
        selectedRole === "Loam Approver" ||
        selectedRole === "TaxTeam" ||
        selectedRole === "Department Coordinator" ||
        selectedRole === "Import" ||
        (selectedRole === "IP" && disabled)) && (
        <>
          {/* Bar code */}
          {newFormState?.isPCDV && (
            <Grid
              item
              xs={12}
              sm={12}
              md={alignForAttachment ? 6 : 3}
              lg={alignForAttachment ? 6 : 3}
            >
              <Typography style={{ color: "black" }}>
                <span className={classes.asterisk}>*</span>
                Bar code:
              </Typography>
              <TextField
                fullWidth
                size="small"
                sx={{
                  "& .MuiInputBase-root": {
                    height: 30,
                  },
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                id="outlined-basic"
                variant="outlined"
                type="text"
                disabled={disabled}
                name="barcode_No"
                value={newFormState?.barcode_No}
                // onChange={changeHandler}
              />
            </Grid>
          )}

          {/* IP user */}
          {!newFormState?.isPCDV &&
            selectedRole !== "IP" &&
            selectedRole !== "Loam Approver" &&
            disabled && (
              <>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={alignForAttachment ? 6 : 3}
                  lg={alignForAttachment ? 6 : 3}
                >
                  <FormControl fullWidth size="small">
                    <UsersByRole
                      label="IP User"
                      placehold="IP User"
                      apiString="IP"
                      name="ipUser"
                      formState={newFormState}
                      changeHandler={changeHandler}
                      required={true}
                      disabled={disabled}
                      classes={classes}
                    />
                    {/* <Roleapidata /> */}
                  </FormControl>
                </Grid>
              </>
            )}
        </>
      )}

      {(selectedRole === "I2P Initiator" ||
        selectedRole === "IR" ||
        (selectedRole === "IP" &&
          disabled &&
          !newFormState?.isImport &&
          !newFormState?.isHR) ||
        (selectedRole === "Buyer" && disabled)) && (
        <>
          {/* GRN Number */}
          {poBasedState == "PO" && (
            <>
              {newFormState?.grn_No !== "" && (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={alignForAttachment ? 6 : 3}
                  lg={alignForAttachment ? 6 : 3}
                >
                  <Typography style={{ color: "black" }}>
                    GRN Number:
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    sx={{
                      "& .MuiInputBase-root": {
                        height: 30,
                      },
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    id="outlined-basic"
                    variant="outlined"
                    name="grn_No"
                    disabled={disabled}
                    value={newFormState?.grn_No}
                    onChange={changeHandler}
                  />
                </Grid>
              )}
              {newFormState?.delv_Note_No !== "" && (
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={alignForAttachment ? 6 : 3}
                  lg={alignForAttachment ? 6 : 3}
                >
                  <Typography style={{ color: "black" }}>
                    {newFormState?.pO_No === "" ? (
                      <span className={classes.asterisk}>*</span>
                    ) : null}
                    DN Number:{" "}
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    sx={{
                      "& .MuiInputBase-root": {
                        height: 30,
                      },
                      "& legend": { display: "none" },
                      "& fieldset": { top: 0 },
                    }}
                    id="outlined-basic"
                    variant="outlined"
                    disabled={disabled}
                    name="delv_Note_No"
                    required={newFormState?.pO_No === "" ? true : false}
                    value={newFormState?.delv_Note_No || ""}
                    onChange={changeHandler}
                  />
                </Grid>
              )}
            </>
          )}

          {/* IR user */}
          {selectedRole === "IP" && !disabled ? (
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <FormControl fullWidth size="small">
                <UsersByRole
                  label="IR User"
                  apiString="IR"
                  name="irUser"
                  formState={newFormState}
                  changeHandler={changeHandler}
                  required={true}
                  classes={classes}
                />
              </FormControl>
            </Grid>
          ) : (
            ""
          )}
        </>
      )}

      {selectedRole === "Logistic" ? (
        <>
          <Grid
            item
            xs={12}
            sm={12}
            md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          >
            <FormControl fullWidth size="small">
              <UsersByRole
                label="Logistic Team"
                apiString="Logistic"
                name="logisticsTeam"
                formState={newFormState}
                changeHandler={changeHandler}
                required={true}
                classes={classes}
                disabled={disabled}
              />
            </FormControl>
          </Grid>
        </>
      ) : (
        ""
      )}

      {(selectedRole === "TaxTeam" || selectedRole === "Logistic") &&
        newFormState?.isLogistics &&
        (newFormState?.invoice_Type === "DN" ||
          newFormState?.invoice_Type === "ITN") && (
          <>
            {/* Shipment */}
            {
              <Grid
                item
                xs={12}
                sm={12}
                md={alignForAttachment ? 6 : 3}
                lg={alignForAttachment ? 6 : 3}
              >
                <Typography style={{ color: "black" }}>
                  <span className={classes.asterisk}>*</span>
                  {newFormState?.invoice_Type === "DN" ? "Shipment" : ""}{" "}
                  {newFormState?.invoice_Type === "ITN" ? "STO Number" : ""}
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  sx={{
                    "& .MuiInputBase-root": {
                      height: 30,
                    },
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  id="outlined-basic"
                  variant="outlined"
                  name="pO_No"
                  required
                  disabled={disabled}
                  value={newFormState?.pO_No}
                  onChange={changeHandler}
                />
              </Grid>
            }
          </>
        )}

      {/* Attach Invoice */}

      {/*  {(selectedRole === "Import" ||
        selectedRole === "IR" ||
        selectedRole === "Logistic" ||
        selectedRole === "TaxTeam" ||
        selectedRole === "I2P Initiator" ||
        (selectedRole === "IP" && !edit) ||
        (selectedRole === "Department Coordinator" && !newFormState?.isPCDV) ||
        selectedRole === "Buyer" ||
        (selectedRole === "Loam Approver" &&
          disabled &&
          !newFormState?.isPCDV)) && (
        <>
        {disabled && !newFormState?.isPCDV && (
            <Grid
              item
              xs={12}
              sm={12}
              md={alignForAttachment ? 6 : 3}
              lg={alignForAttachment ? 6 : 3}
            >
              <Typography style={{ color: "black" }}>
                Attach Invoice:
              </Typography>
              <TextField
                fullWidth
                size="small"
                sx={{
                  // width: "70%",
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                id="outlined-basic"
                variant="outlined"
                // required={newFormState?.invoice_attachment?.path === ""}
                disabled={disabled}
                // onChange={() => }
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <input
                        ref={invoice_attachmentRef}
                        type="file"
                        accept=".png, .jpg, .jpeg, .pdf"
                        name="invoice_attachment"
                        onChange={(e) =>
                          uploadFile(
                            e,
                            setNewFormState,
                            setAttachInvoiceLoading,
                            "invoice_attachment",
                            // setAttchmentFile_UI
                            () => {},
                            () => {},
                            () => {},
                            setAttachError
                          )
                        }
                        disabled={disabled}
                        style={{ width: "209px" }}
                      />
                    </InputAdornment>
                  ),
                }}
                FormHelperTextProps={{
                  className: classes.helperText,
                }}
                // error={attachError ? true : false}
                // helperText={attachError ? `${attachError}` : null}
              />
              {newFormState?.invoice_attachment && (
                <>
                  {" "}
                  {!disabled ? (
                    <IconButton
                      size="small"
                      onClick={() => {
                        setNewFormState((formState) => ({
                          ...newFormState,
                          invoice_attachment: {},
                        }));
                        invoice_attachmentRef.current.value = null;
                      }}
                    >
                      <Delete color="danger" fontSize="small" />

                      <span style={{ fontSize: "14px" }}>
                        {
                          newFormState?.invoice_attachment?.path?.split("\\")[
                            newFormState?.invoice_attachment?.path?.split("\\")
                              .length - 1
                          ]
                        }
                      </span>
                    </IconButton>
                  ) : (
                    <>
                      <Download
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          downloadAttachments(
                            newFormState?.invoice_attachment?.path
                          );
                        }}
                      />
                      <IconButton
                        style={{
                          fontSize: "12px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          const allowedExtensions = [
                            ".png",
                            ".pdf",
                            ".jpg",
                            ".jpeg",
                            ".PNG",
                            ".JPG",
                            ".JPEG",
                            ".PNG",
                            ".PDF",
                          ];
                          const fileExtension =
                            "." +
                            newFormState?.invoice_attachment?.path
                              ?.split("\\")
                              [
                                newFormState?.invoice_attachment?.path?.split(
                                  "\\"
                                ).length - 1
                              ].split(".")
                              .pop();
                          if (allowedExtensions.includes(fileExtension)) {
                            showAttachmentsHandler(
                              newFormState?.invoice_attachment
                            );
                          } else {
                            showAttachmentsHandler(
                              newFormState?.invoice_attachment
                            );
                            window.open(
                              `${process.env.REACT_APP_API_URL}/${newFormState?.invoice_attachment?.path}`,
                              "_blank"
                            );
                          }
                        }}
                        s
                      >
                        <span style={{ fontSize: "14px" }}>
                          {
                            newFormState?.invoice_attachment?.path?.split("\\")[
                              newFormState?.invoice_attachment?.path?.split(
                                "\\"
                              ).length - 1
                            ]
                          }
                        </span>
                      </IconButton>
                    </>
                  )}
                </>
              )}
            </Grid>
           )}
           </>

                        )}
                      */}

      {(selectedRole === "IP" || selectedRole === "Line Manager") && (
        <>
          {disabled && newFormState?.lineManager && (
            <Grid item xs={12} sm={12} md={6} lg={6}>
              <UsersByRole
                label="Line Manager"
                apiString="Line Manager"
                name="lineManager"
                formState={newFormState}
                changeHandler={changeHandler}
                required={true}
                classes={classes}
                disabled={disabled}
              />
            </Grid>
          )}
          {disabled &&
            newFormState?.sharedServices &&
            newFormState?.invoiceCategory !== "Employee Advance" &&
            newFormState?.invoiceCategory !== "Employee Loan" && (
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <UsersByRole
                  label="Shared Services"
                  apiString="Shared Services"
                  name="sharedServices"
                  formState={newFormState}
                  changeHandler={changeHandler}
                  required={true}
                  classes={classes}
                  disabled={disabled}
                />
              </Grid>
            )}
          {disabled &&
            newFormState?.directorHR &&
            newFormState?.invoiceCategory !== "Employee Advance" &&
            newFormState?.invoiceCategory !== "Employee Loan" && (
              <Grid item xs={12} sm={12} md={6} lg={6}>
                <UsersByRole
                  label="Director HR"
                  apiString="Director HR"
                  name="directorHR"
                  formState={newFormState}
                  changeHandler={changeHandler}
                  required={true}
                  classes={classes}
                  disabled={disabled}
                />
              </Grid>
            )}
        </>
      )}
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{
          marginLeft: "0px",
        }}
      >
        {disabled && (
          <Typography style={{ color: "black" }}>Attachments:</Typography>
        )}
        {(selectedRole === "Import" ||
          selectedRole === "IR" ||
          selectedRole === "Logistic" ||
          selectedRole === "TaxTeam" ||
          selectedRole === "I2P Initiator" ||
          (selectedRole === "IP" && !edit) ||
          selectedRole === "Department Coordinator" ||
          selectedRole === "Line Manager" ||
          selectedRole === "View Only" ||
          // (selectedRole === "Department Coordinator" &&
          //   !newFormState?.isPCDV) ||
          selectedRole === "Buyer" ||
          (selectedRole === "Loam Approver" && disabled)) && (
          <>
            {disabled && (
              <>
                {newFormState?.invoice_attachment && (
                  <>
                    <IconButton
                      size="small"
                      onClick={() => {
                        downloadAttachments(
                          newFormState?.invoice_attachment?.path
                        );
                      }}
                    >
                      <Download color="secondary" />{" "}
                    </IconButton>
                    <a
              href={`${process.env.REACT_APP_API_URL}/${newFormState?.invoice_attachment?.path}`}
              target="_blank"
            >
              <Button
                // variant="outlined"
                color="primary"
                size="small"
                // onClick={() => downloadImage(attachmentURL)}
                sx={{ mr: 2 }}
              >
                <Tooltip title="Preview on Tab">
                  <BackupTable />
                </Tooltip>
              </Button>
            </a>
                    {/* <IconButton
                      size="small"
                      disabled={disabled}
                      onClick={() => {
                        setNewFormState((formState) => ({
                          ...newFormState,
                          invoice_attachment: {},
                        }));
                        invoice_attachmentRef.current.value = null;
                      }}
                    >
                      <Delete
                        titleAccess="Delete"
                        // color="danger"
                        fontSize="small"
                        style={{
                          color: disabled ? "gray" : "",
                        }}
                      />
                    </IconButton> */}
                    <>
                      <IconButton
                        style={{
                          fontSize: "12px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          const allowedExtensions = [
                            ".png",
                            ".pdf",
                            ".jpg",
                            ".jpeg",
                            ".PNG",
                            ".JPG",
                            ".JPEG",
                            ".PNG",
                            ".PDF",
                          ];
                          const fileExtension =
                            "." +
                            newFormState?.invoice_attachment?.path
                              ?.split("\\")
                              [
                                newFormState?.invoice_attachment?.path?.split(
                                  "\\"
                                ).length - 1
                              ].split(".")
                              .pop();
                          if (allowedExtensions.includes(fileExtension)) {
                            showAttachmentsHandler(
                              newFormState?.invoice_attachment
                            );
                          } else {
                            showAttachmentsHandler(
                              newFormState?.invoice_attachment
                            );
                            window.open(
                              `${process.env.REACT_APP_API_URL}/${newFormState?.invoice_attachment?.path}`,
                              "_blank"
                            );
                          }
                        }}
                        s
                      >
                        <span style={{ fontSize: "14px" }}>
                          {
                            newFormState?.invoice_attachment?.path?.split("\\")[
                              newFormState?.invoice_attachment?.path?.split(
                                "\\"
                              ).length - 1
                            ]
                          }
                        </span>
                      </IconButton>
                    </>
                  </>
                )}
              </>
            )}
          </>
        )}
        {(selectedRole === "Import" ||
          selectedRole === "I2P Initiator" ||
          selectedRole === "Department Coordinator" ||
          selectedRole === "Loam Approver" ||
          selectedRole === "IR" ||
          selectedRole === "HR" ||
          selectedRole === "Line Manager" ||
          selectedRole === "EFDV Initiator" ||
          selectedRole === "TaxTeam" ||
          selectedRole === "Logistic" ||
          selectedRole === "Buyer" ||
          selectedRole === "View Only" ||
          (selectedRole === "IP" && disabled)) && (
          <>
            {newFormState?.additionalDocIds?.length > 0 &&
              newFormState?.additionalDocIds?.map((f, index) => {
                const s = f?.path?.split("\\");
                const ss = s[s.length - 1];
                return (
                  <div>
                    {f?.path !== "" ? (
                      <>
                      
                        <IconButton
                          size="small"
                          onClick={() => {
                            downloadAttachments(f?.path);
                          }}
                        >
                          <Download color="secondary" />{" "}
                        </IconButton>
                        <a
              href={`${process.env.REACT_APP_API_URL}/${f?.path}`}
              target="_blank"
            >
              <Button
                // variant="outlined"
                color="primary"
                size="small"
                // onClick={() => downloadImage(attachmentURL)}
                sx={{ mr: 2 }}
              >
                <Tooltip title="Preview on Tab">
                  <BackupTable />
                </Tooltip>
              </Button>
            </a>
                        <IconButton
                            size="small"
                            // disabled={f?.role_Name !== selectedRole}
                            onClick={() => {
                              setCurrentStateForDeleteion(f);
                              setOpenWarningBox(true);
                              setWarningFlag(true);
                            }}
                          >
                            <Delete
                              titleAccess="Delete"
                              color="danger"
                              fontSize="small"
                              // style={{
                              //   color:
                              //     // disable ||
                              //     f?.role_Name !== selectedRole ? "gray" : "",
                              // }}
                            />
                          </IconButton>
                     

                        <IconButton
                          size="small"
                          onClick={() => {
                            const allowedExtensions = [
                              ".png",
                              ".pdf",
                              ".jpg",
                              ".jpeg",
                              ".PNG",
                              ".JPG",
                              ".JPEG",
                              ".PNG",
                              ".PDF",
                            ];
                            const fileExtension = "." + ss.split(".").pop();
                            if (allowedExtensions.includes(fileExtension)) {
                              setAttachmentURL(f);
                            } else {
                              setAttachmentURL(f);

                              window.open(
                                `${process.env.REACT_APP_API_URL}/${f.path}`,
                                "_blank"
                              );
                            }
                          }}
                        >
                          <span style={{ fontSize: "12px" }}>{ss}</span>
                        </IconButton>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                );
              })}
          </>
        )}
      </Grid>

      {(selectedRole === "Import" ||
        selectedRole === "IR" ||
        selectedRole === "EFDV Initiator" ||
        selectedRole === "I2P Initiator" ||
        selectedRole === "HR") && (
        // selectedRole === "Logistic"
        <>
          {/* comments */}
          <Grid
            item
            xs={12}
            sm={12}
            md={selectedRole === "HR" ? 6 : 3}
            lg={selectedRole === "HR" ? 6 : 12}
          >
            <Typography style={{ color: "black" }}>
              Comments:
              {/* <span className={classes.asterisk}>*</span> */}
            </Typography>
            <TextField
              fullWidth
              // multiline
              // rows={2}
              // maxRows={4}
              size="small"
              sx={{
                // width: "70%",
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-basic"
              variant="outlined"
              name="comments"
              value={newFormState?.comments}
              onChange={changeHandler}
            />
          </Grid>
        </>
      )}
      {selectedRole === "IR" && (
        <>
          {/* Additional comments */}
          <Grid item xs={12} sm={12} md={3} lg={12}>
            <Typography style={{ color: "black" }}>
              <span className={classes.asterisk}>*</span>
              Additional Comments:
            </Typography>
            <TextField
              fullWidth
              multiline
              value={newFormState?.aditional_Comments}
              onChange={changeHandler}
              // rows={2}
              maxRows={4}
              // size="small"
              sx={{
                "& .MuiInputBase-root": {
                  height: 30,
                },
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              id="outlined-basic"
              variant="outlined"
            />
          </Grid>
        </>
      )}

      {/* //Comment history */}
      {/* {selectedRole === "IR" && (
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <CommentHistory
            commentsList={commentsList}
            commentsLoading={commentsLoading}
          />
        </Grid>
      )} */}
      {selectedRole === "IR" ? (
        <>
          {newFormState?.pO_No && (
            <Grid container spacing={2} style={{ marginTop: "30px" }}>
              <Grid item xs={12} sm={12} md={6} lg={12}>
                <PODetail
                  formState={newFormState}
                  setNewFormState={setNewFormState}
                />
              </Grid>
            </Grid>
          )}
        </>
      ) : (
        ""
      )}
      {openWarningBox && (
        <WarningBox
          open={openWarningBox}
          close={() => setOpenWarningBox(false)}
          // submit={deleteAttachmentFunc}
          submit={warningFlag ? deleteAttachmentFunc : deleteInvoice}
          message="Are you sure to delete attachment"
          deleteLoader={deleteLoader}
        />
      )}
      {alertMessage && (
        <POAlertDialog
          setAlertMessage={setAlertMessage}
          message={attachError ? attachError : docError}
          setAttachError={setAttachError}
          setDocError={setDocError}
          allow={1}
        />
      )}
    </Grid>
  );
};

export default InvoiceTextField;
